module.exports = __webpack_public_path__ + "static/img/thumb_11.7700b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_11.jpg
// module id = C10n
// module chunks = 0